import React from "react";
import csc from "../assets/csc.png";
import { draCourseIds } from "../config";
import { getCourseIds } from "../utils/getCourseIds";
export default function BaseLayout({
  noIcon,
  children,
}: {
  readonly noIcon?: boolean;
  readonly children: any;
}) {
  const courseIds = getCourseIds();

  const isDRA = courseIds?.some((id) => draCourseIds.includes(id));
  return (
    <div className="flex items-center justify-center bg-img py-6 px-10">
      <div className="w-full p-8 bg-white rounded-lg flex justify-center max-w-[900px]">
        <div className="w-full">
          {!noIcon && (
            <div className="flex justify-between items-center w-full space-x-4 mt-4">
              {/* <img alt="" src={iibf} className="h-7 sm:h-10 md:h-12" /> */}
              <h6 className="iibf-logo">
                {courseIds == draCourseIds
                  ? "DRA Training Program"
                  : "BC Training Program"}
              </h6>
              {/* <img alt="" src={logo} className="h-7 sm:h-10 md:h-12" /> */}
              <img alt="" src={csc} className="h-7 sm:h-10 md:h-12" />
            </div>
          )}
          {!isDRA && (
            <div className="bg-yellow-100 border border-yellow-400 text-yellow-900 px-6 py-4 rounded-md  text-sm md:text-base font-semibold my-4">
              Attention Candidates: Individuals trained through CSC Academy in
              BC Advanced/ Basic course are restricted from taking exams at any
              CSC Center. Please select an alternative authorized exam center
              through IIBF Portal
              <a
                className="text-red-500"
                href="https://iibf.esdsconnect.com/iibfbcbf/apply_exam_individual?ctype=Tk0="
              >
                (https://iibf.esdsconnect.com/iibfbcbf/apply_exam_individual?ctype=Tk0=)
              </a>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
